import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  constructor() {}

  /**
   * Store data in session storage
   * @param key - The key to store the data under
   * @param data - The data to store
   */
  setSessionData<T>(key: string, data: T): void {
    try {
      const serializedData = JSON.stringify(data);
      sessionStorage.setItem(key, serializedData);
    } catch (error) {
      console.error('Error storing data in session storage:', error);
      Sentry.captureException(error, {
        tags: {
          location: 'cacheService',
          action: 'setSessionData',
        },
        extra: {
          key,
          data,
        },
      });
    }
  }

  /**
   * Retrieve data from session storage
   * @param key - The key to retrieve data from
   * @returns The stored data or null if not found
   */
  getSessionData<T>(key: string): T | null {
    try {
      if (!sessionStorage.hasOwnProperty(key)) {
        return null;
      }

      const data = sessionStorage.getItem(key);
      return JSON.parse(data) as T;
    } catch (error) {
      console.error('Error retrieving data from session storage:', error);
      Sentry.captureException(error, {
        tags: {
          location: 'cacheService',
          action: 'getSessionData',
        },
        extra: {
          key,
        },
      });
      return null;
    }
  }
}
